module.exports = __webpack_public_path__ + "img/logo.e605b515.jpeg";